const ADJ = [
  "neon",
  "lunar",
  "static",
  "cosmic",
  "velvet",
  "midnight",
  "ember",
  "pixel",
  "sonic",
  "glass",
  "echo",
  "frost",
  "cyan",
  "amber",
  "silk",
  "mirror",
  "haze",
  "spark",
  "quartz",
  "shadow",
  "ghost",
  "rune",
  "iris",
  "nova",
  "dusk",
  "plush",
  "hyper",
  "clover",
  "glitch",
  "bloom",
  "radio",
  "solar",
  "arcane",
  "retro",
];

const NOUN = [
  "fox",
  "wolf",
  "kite",
  "rose",
  "wave",
  "storm",
  "moth",
  "crow",
  "flux",
  "bloom",
  "orbit",
  "pulse",
  "drift",
  "comet",
  "tide",
  "flame",
  "ash",
  "rain",
  "star",
  "rift",
  "echo",
  "noise",
  "ghost",
  "prism",
  "riot",
  "vapor",
  "ion",
  "glow",
  "fawn",
  "jet",
  "sigil",
  "clash",
  "coda",
  "halo",
  "spire",
];

/** Generate a fresh nickname like `neon.fox`, `lunar_wave.42`, `velvet23`. */
export function generateNickname(): string {
  const adj = ADJ[Math.floor(Math.random() * ADJ.length)];
  const noun = NOUN[Math.floor(Math.random() * NOUN.length)];
  const num = Math.floor(Math.random() * 100);
  const formats = [
    () => `${adj}.${noun}`,
    () => `${adj}_${noun}`,
    () => `${adj}.${noun}.${num}`,
    () => `${adj}${num}`,
    () => `${noun}.${adj}`,
  ];
  const pick = formats[Math.floor(Math.random() * formats.length)]!;
  return pick();
}

/** Sanitize user-edited handle to terminal-clean, lowercase, max 18 chars. */
export function sanitizeHandle(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]/g, "")
    .slice(0, 18);
}
